// extracted by mini-css-extract-plugin
export default {"root":"Empty_root__TKW3Z","inner":"Empty_inner__R8srP","icon":"Empty_icon__yhgw2","title":"Empty_title__SzFXV","message":"Empty_message__mml-j","logo":"Empty_logo__3m7mv"};